import { useEffect, useState } from "react";
import { useT } from "../features/i18n/useT";
import { usePageTag } from "../app/usePageTag";

import { AppearanceCard } from "../features/settings/AppearanceCard";
import { LanguageCard } from "../features/settings/LanguageCard";
import { CalendarCard } from "../features/settings/CalendarCard";
import { RemindersCard } from "../features/settings/RemindersCard";
import { SocialsCard } from "../features/settings/SocialsCard";
import { GroupPickerCard } from "../features/settings/GroupPickerCard";

export default function SettingsPage() {
  usePageTag("settings");
  const t = useT();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`page settings-page ${isLoading ? "loading" : ""}`}>
      <h2>{t("settings.title")}</h2>

      <AppearanceCard />
      <LanguageCard />

      <GroupPickerCard />

      <CalendarCard />
      <section className="settings-card ics-help">
        <h3>{t("settings.icsHelp.title")}</h3>
        <ol className="ics-steps">
          <li>{t("settings.icsHelp.step1")}</li>
          <li>{t("settings.icsHelp.step2")}</li>
          <li>{t("settings.icsHelp.step3")}</li>
        </ol>
        <div className="ics-images">
          <a className="ics-image-link is-compact" href="/help/ics/screen-1.png" target="_blank" rel="noreferrer">
            <img src="/help/ics/screen-1.png" alt={t("settings.icsHelp.step1Alt")} loading="lazy" />
          </a>
          <a className="ics-image-link" href="/help/ics/screen-2.png" target="_blank" rel="noreferrer">
            <img src="/help/ics/screen-2.png" alt={t("settings.icsHelp.step2Alt")} loading="lazy" />
          </a>
        </div>
      </section>
      <RemindersCard />

      <SocialsCard />
    </div>
  );
}

